module.exports = __webpack_public_path__ + "static/media/brl.de272ba6.svg";